import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core";


@Component({
    selector: 'kort-handlinger',
    template: '<ng-content/>',
    styleUrl: 'kort-handlinger.scss',
    host: {
        '[class.justering-venstre]': 'knappejustering == "venstre"',
        '[class.justering-sentrert]': 'knappejustering == "sentrert"',
        '[class.justering-hoyere]': 'knappejustering == "hoyere"',
        '[class.justering-luftMellom]': 'knappejustering == "luftMellom"',
    },
    imports: [
        TranslateModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class KortHandlingerKomponent {
    constructor() {
    }

    @Input() knappejustering: 'venstre' | 'sentrert' | 'hoyere' | 'luftMellom' | null = null;
}
